import React from 'react';
import LinkList from '../components/linkList';
import { themePropType } from '../components/sharedPropTypes';
import PropTypes from 'prop-types';
const LinksPage = ({ theme, onBackClick }) => {
  const followMeLinks = [
    { text: 'Pixel Instagram', url: 'https://www.instagram.com/bizbunny_pixels/' },
    { text: 'Instagram', url: 'https://www.instagram.com/anh_bizbunny/' },
    {text: 'TikTok', url: 'https://www.tiktok.com/@bizbunny_pixels'},
    {text: 'Cara', url: 'https://cara.app/anhbizbunny/all'},
    { text: 'BlueSky', url: 'https://bsky.app/profile/bizbunny.bsky.social' },
    { text: 'Cara', url: 'https://cara.app/anhbizbunny/all' },
    { text: 'Youtube', url: 'https://www.youtube.com/@Bizbunny_Pixels' }
  ];
  const codeLinks = [
    { text: 'GitHub', url: 'https://github.com/bizbunny' },
    { text: 'Itchio', url: 'https://anh-bizbunny.itch.io' },
    { text: 'CodePen', url: 'https://codepen.io/anh_bizbunny'}
  ];
  const meetMyOCsLinks = [
    { text: 'UnVale', url: 'https://unvale.io/bizbunny'},
    { text: 'Toy House', url: 'https://toyhou.se/anhbizbunny'}
  ];
  const commissionLinks = [
    {text: 'VGen', url: 'https://vgen.co/anhbizbunny'},
    {text: 'KoFi', url: 'https://ko-fi.com/anh_bizbunny'}
  ];
    return (
      <div className='linksPage'>  
        <div className="linksPageContainer">
          <div className="linkListColumn">
            <h3>Commission Me</h3>
            <LinkList theme={theme} links={commissionLinks} />
          </div>
          <div className="linkListColumn">
            <h3>Developer</h3>
            <LinkList theme={theme} links={codeLinks} />
          </div>
          <div className="linkListColumn">
            <h3>OCs & FCs</h3>
            <LinkList theme={theme} links={meetMyOCsLinks} />
          </div>
          <div className="linkListColumn">
            <h3>Socials</h3>
            <LinkList theme={theme} links={followMeLinks} />
          </div>

        </div>
      </div>
    );
  };
  LinksPage.propTypes = {
    theme: themePropType,
    onBackClick: PropTypes.func
  };

  export default LinksPage;